<template>
  <div>
    <div class="p-4 bg-black relative overflow-hidden mb-4 shadow-lg">
      <!-- Background -->
      <div class="absolute left-0 right-0 top-0 bottom-0 opacity-50">
        <img class="object-cover flex w-full" :src="api_url + place.banner_pic_url" />
      </div>
      <!-- Logo -->
      <div class="relative rounded-full mx-auto my-4 shadow-lg w-24 h-24 flex border-solid border-2 border-black bg-white">
        <img class="rounded-full object-contain flex" :src="api_url + place.profile_pic_url" />
      </div>
    </div>

    <!-- Nombre de negocio -->
    <div class="flex items-center mb-4">
      <div class="rounded-full bg-white shadow-lg relative mx-auto -mt-8 px-4 py-1">
        <h1 class="text-xl font-bold text-gray-900 text-center">{{ place.name }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PleaceHeader',
  props: {
    place: Object
  },
  data() {
    return {
       api_url: process.env.VUE_APP_URL_API
    }
  },
}
</script>

<style scoped lang="scss">

</style>
